
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gMGbk", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $jQW4q = parcelRequire("jQW4q");


var $3gadb = parcelRequire("3gadb");


var $inPa6 = parcelRequire("inPa6");


var $jyA9t = parcelRequire("jyA9t");


var $8uM2K = parcelRequire("8uM2K");


var $aHcFH = parcelRequire("aHcFH");


var $jmjWc = parcelRequire("jmjWc");


var $jln20 = parcelRequire("jln20");


const $e7d7957021bd9d4a$var$remixObjectPagePopupLoader = ()=>(parcelRequire("6njW5"));
const $e7d7957021bd9d4a$var$RemixObjectPagePopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "P1Fw7",
    name: "RemixObjectPagePopup",
    loader: async ()=>(await $e7d7957021bd9d4a$var$remixObjectPagePopupLoader()).RemixObjectPagePopup
});
const $e7d7957021bd9d4a$var$remixButtonContainerStyle = null;
const $e7d7957021bd9d4a$var$popupTriggerOverlayStyle = null;
const $e7d7957021bd9d4a$var$placeholderButtonStyle = null;
const $e7d7957021bd9d4a$var$i18n = (0, $aXWIB.defineMessages)({
    remixPageLabel: {
        id: "object-sidebar-components.remix-page.label",
        defaultMessage: "Remix page"
    },
    remixPageTooltip: {
        id: "object-sidebar-components.remix-page.tooltip",
        defaultMessage: "Remix"
    },
    remixPageEmptyTooltip: {
        id: "object-sidebar-components.remix-page.empty-tooltip",
        defaultMessage: "Add content to this page to remix"
    },
    remixInProgressTooltip: {
        id: "object-sidebar-components.remix-page.in-progress-tooltip",
        defaultMessage: "Remix in progress"
    }
});
const $e7d7957021bd9d4a$var$parseAdf = (value)=>{
    try {
        const parsed = JSON.parse(value);
        if (!parsed || parsed.type !== 'doc') return null;
        return parsed;
    } catch  {
        return null;
    }
};
const $e7d7957021bd9d4a$export$def261f8e2f8a585 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { contentBodyValue: contentBodyValue, getAdfDocument: getAdfDocument, isEditorEmpty: isEditorEmpty, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    let t2;
    if ($[0] !== rightSidebarContext) {
        t2 = rightSidebarContext.getCurrent() || {};
        $[0] = rightSidebarContext;
        $[1] = t2;
    } else t2 = $[1];
    const { width: rightSidebarWidth } = t2;
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [lazyAdfDocument, setLazyAdfDocument] = (0, $42omo.useState)(null);
    const [viewOpenAdfDocument, setViewOpenAdfDocument] = (0, $42omo.useState)(null);
    let t3;
    bb0: {
        if (getAdfDocument) {
            t3 = false;
            break bb0;
        }
        if (!contentBodyValue) {
            t3 = false;
            break bb0;
        }
        let t4;
        if ($[2] !== contentBodyValue) {
            const parsed = $e7d7957021bd9d4a$var$parseAdf(contentBodyValue);
            t4 = parsed !== null && !(0, $aHcFH.isEmptyAdf)(parsed);
            $[2] = contentBodyValue;
            $[3] = t4;
        } else t4 = $[3];
        t3 = t4;
    }
    const hasContentFromBody = t3;
    const hasContent = getAdfDocument ? !isEditorEmpty : hasContentFromBody;
    const resolvedAdfDocument = getAdfDocument ? lazyAdfDocument : viewOpenAdfDocument;
    const [hasBeenActivated, setHasBeenActivated] = (0, $42omo.useState)(false);
    const [isLoadingChunk, setIsLoadingChunk] = (0, $42omo.useState)(false);
    const handlePreload = $e7d7957021bd9d4a$var$_temp;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsModalOpen(false);
            setViewOpenAdfDocument(null);
            setLazyAdfDocument(null);
        };
        $[4] = t4;
    } else t4 = $[4];
    const closeModal = t4;
    let t5;
    if ($[5] !== contentBodyValue || $[6] !== createAnalyticsEvent || $[7] !== getAdfDocument || $[8] !== hasContent || $[9] !== isLoadingChunk || $[10] !== isModalOpen || $[11] !== showSmartCreationModal) {
        t5 = async ()=>{
            if (!hasContent || showSmartCreationModal) return;
            if (isModalOpen || isLoadingChunk) {
                closeModal();
                return;
            }
            setIsLoadingChunk(true);
            await $e7d7957021bd9d4a$var$remixObjectPagePopupLoader();
            setIsLoadingChunk(false);
            if (getAdfDocument) {
                const doc = await getAdfDocument();
                if (doc) {
                    setLazyAdfDocument(doc);
                    setIsModalOpen(true);
                    setHasBeenActivated(true);
                }
            } else if (contentBodyValue) {
                const doc_0 = $e7d7957021bd9d4a$var$parseAdf(contentBodyValue);
                if (doc_0) {
                    setViewOpenAdfDocument(doc_0);
                    setIsModalOpen(true);
                    setHasBeenActivated(true);
                }
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "remix",
                    source: "remixModalFromObjectSidebar",
                    attributes: {
                        entryPoint: "objectSidebar"
                    }
                }
            }).fire();
        };
        $[5] = contentBodyValue;
        $[6] = createAnalyticsEvent;
        $[7] = getAdfDocument;
        $[8] = hasContent;
        $[9] = isLoadingChunk;
        $[10] = isModalOpen;
        $[11] = showSmartCreationModal;
        $[12] = t5;
    } else t5 = $[12];
    const handleClick = t5;
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (options)=>{
            if (options?.reopenModal) setIsModalOpen(true);
        };
        $[13] = t6;
    } else t6 = $[13];
    const onStopThinking = t6;
    let t7;
    if ($[14] !== formatMessage || $[15] !== hasContent || $[16] !== isModalOpen || $[17] !== showSmartCreationModal) {
        t7 = isModalOpen && !showSmartCreationModal ? undefined : showSmartCreationModal ? formatMessage($e7d7957021bd9d4a$var$i18n.remixInProgressTooltip) : hasContent ? formatMessage($e7d7957021bd9d4a$var$i18n.remixPageTooltip) : formatMessage($e7d7957021bd9d4a$var$i18n.remixPageEmptyTooltip);
        $[14] = formatMessage;
        $[15] = hasContent;
        $[16] = isModalOpen;
        $[17] = showSmartCreationModal;
        $[18] = t7;
    } else t7 = $[18];
    const tooltipContent = t7;
    let t8;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $gMc0m.default)([
            "_kqswh2mm"
        ]);
        $[19] = t8;
    } else t8 = $[19];
    const t9 = isRovoButtonEnabled ? "default" : "circle";
    let t10;
    if ($[20] !== formatMessage) {
        t10 = formatMessage($e7d7957021bd9d4a$var$i18n.remixPageLabel);
        $[20] = formatMessage;
        $[21] = t10;
    } else t10 = $[21];
    const t11 = isDisabled || !hasContent || showSmartCreationModal;
    let t12;
    if ($[22] !== handleClick || $[23] !== isLoadingChunk || $[24] !== t10 || $[25] !== t11 || $[26] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            onClick: handleClick,
            appearance: "subtle",
            shape: t9,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
            label: t10,
            testId: "sidebar-remix-button",
            isLoading: isLoadingChunk,
            isDisabled: t11
        });
        $[22] = handleClick;
        $[23] = isLoadingChunk;
        $[24] = t10;
        $[25] = t11;
        $[26] = t9;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== t12 || $[29] !== tooltipContent) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: tooltipContent,
            hideTooltipOnClick: true
        }, t12);
        $[28] = t12;
        $[29] = tooltipContent;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== formatMessage || $[32] !== hasBeenActivated || $[33] !== hasContent || $[34] !== isDisabled || $[35] !== isModalOpen || $[36] !== isRovoButtonEnabled || $[37] !== resolvedAdfDocument || $[38] !== rightSidebarWidth || $[39] !== showSmartCreationModal) {
        t14 = hasBeenActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e7d7957021bd9d4a$var$RemixObjectPagePopup, {
            adfDocument: resolvedAdfDocument ?? {
                type: "doc",
                version: 1,
                content: []
            },
            isModalOpen: isModalOpen,
            onClose: closeModal,
            onStopThinking: onStopThinking,
            popupRepositionKey: rightSidebarWidth,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                    className: (0, $gMc0m.default)([
                        "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _lcxvglyw"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                    ...triggerProps,
                    appearance: "subtle",
                    shape: isRovoButtonEnabled ? "default" : "circle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
                    label: formatMessage($e7d7957021bd9d4a$var$i18n.remixPageLabel),
                    testId: "sidebar-remix-button",
                    isDisabled: isDisabled || !hasContent || showSmartCreationModal,
                    isSelected: isModalOpen && !showSmartCreationModal,
                    "aria-hidden": "true",
                    className: (0, $gMc0m.default)([
                        "_3um015vq"
                    ])
                }))
        });
        $[31] = formatMessage;
        $[32] = hasBeenActivated;
        $[33] = hasContent;
        $[34] = isDisabled;
        $[35] = isModalOpen;
        $[36] = isRovoButtonEnabled;
        $[37] = resolvedAdfDocument;
        $[38] = rightSidebarWidth;
        $[39] = showSmartCreationModal;
        $[40] = t14;
    } else t14 = $[40];
    let t15;
    if ($[41] !== t13 || $[42] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: handlePreload,
            onFocus: handlePreload,
            className: t8
        }, t13, t14);
        $[41] = t13;
        $[42] = t14;
        $[43] = t15;
    } else t15 = $[43];
    return t15;
} : ({ contentBodyValue: contentBodyValue, getAdfDocument: getAdfDocument, isEditorEmpty: isEditorEmpty, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { width: rightSidebarWidth } = rightSidebarContext.getCurrent() || {};
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [lazyAdfDocument, setLazyAdfDocument] = (0, $42omo.useState)(null);
    const [viewOpenAdfDocument, setViewOpenAdfDocument] = (0, $42omo.useState)(null);
    const hasContentFromBody = (0, $42omo.useMemo)(()=>{
        if (getAdfDocument) return false;
        if (!contentBodyValue) return false;
        const parsed = $e7d7957021bd9d4a$var$parseAdf(contentBodyValue);
        return parsed !== null && !(0, $aHcFH.isEmptyAdf)(parsed);
    }, [
        contentBodyValue,
        getAdfDocument
    ]);
    const hasContent = getAdfDocument ? !isEditorEmpty : hasContentFromBody;
    const resolvedAdfDocument = getAdfDocument ? lazyAdfDocument : viewOpenAdfDocument; // Tracks whether the popup has ever been activated so the lazy chunk is loaded
    const [hasBeenActivated, setHasBeenActivated] = (0, $42omo.useState)(false);
    const [isLoadingChunk, setIsLoadingChunk] = (0, $42omo.useState)(false); // Preload the heavy popup chunk on hover/focus so it's ready by the time the user clicks
    const handlePreload = (0, $42omo.useCallback)(()=>{
        $e7d7957021bd9d4a$var$remixObjectPagePopupLoader();
    }, []);
    const closeModal = (0, $42omo.useCallback)(()=>{
        setIsModalOpen(false);
        setViewOpenAdfDocument(null);
        setLazyAdfDocument(null);
    }, []);
    const handleClick = (0, $42omo.useCallback)(async ()=>{
        if (!hasContent || showSmartCreationModal) return;
        if (isModalOpen || isLoadingChunk) {
            closeModal();
            return;
        } // Ensure the popup chunk is loaded before opening — the hover preload
        // means this will typically resolve instantly from cache
        setIsLoadingChunk(true);
        await $e7d7957021bd9d4a$var$remixObjectPagePopupLoader();
        setIsLoadingChunk(false);
        if (getAdfDocument) {
            const doc = await getAdfDocument();
            if (doc) {
                setLazyAdfDocument(doc);
                setIsModalOpen(true);
                setHasBeenActivated(true);
            }
        } else if (contentBodyValue) {
            const doc_0 = $e7d7957021bd9d4a$var$parseAdf(contentBodyValue);
            if (doc_0) {
                setViewOpenAdfDocument(doc_0);
                setIsModalOpen(true);
                setHasBeenActivated(true);
            }
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'remix',
                source: 'remixModalFromObjectSidebar',
                attributes: {
                    entryPoint: 'objectSidebar'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        hasContent,
        isModalOpen,
        showSmartCreationModal,
        closeModal,
        isLoadingChunk,
        getAdfDocument,
        contentBodyValue
    ]);
    const onStopThinking = (0, $42omo.useCallback)((options)=>{
        if (options?.reopenModal) setIsModalOpen(true);
    }, []);
    const tooltipContent = isModalOpen && !showSmartCreationModal ? undefined : showSmartCreationModal ? formatMessage($e7d7957021bd9d4a$var$i18n.remixInProgressTooltip) : hasContent ? formatMessage($e7d7957021bd9d4a$var$i18n.remixPageTooltip) : formatMessage($e7d7957021bd9d4a$var$i18n.remixPageEmptyTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: handlePreload,
        onFocus: handlePreload,
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: tooltipContent,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: handleClick,
        appearance: "subtle",
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
        label: formatMessage($e7d7957021bd9d4a$var$i18n.remixPageLabel),
        testId: "sidebar-remix-button",
        isLoading: isLoadingChunk,
        isDisabled: isDisabled || !hasContent || showSmartCreationModal
    })), hasBeenActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e7d7957021bd9d4a$var$RemixObjectPagePopup, {
        adfDocument: resolvedAdfDocument ?? {
            type: 'doc',
            version: 1,
            content: []
        },
        isModalOpen: isModalOpen,
        onClose: closeModal,
        onStopThinking: onStopThinking,
        popupRepositionKey: rightSidebarWidth,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _lcxvglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                appearance: "subtle",
                shape: isRovoButtonEnabled ? 'default' : 'circle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jQW4q))),
                label: formatMessage($e7d7957021bd9d4a$var$i18n.remixPageLabel),
                testId: "sidebar-remix-button",
                isDisabled: isDisabled || !hasContent || showSmartCreationModal,
                isSelected: isModalOpen && !showSmartCreationModal,
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    "_3um015vq"
                ])
            }))
    }));
};
function $e7d7957021bd9d4a$var$_temp() {
    $e7d7957021bd9d4a$var$remixObjectPagePopupLoader();
}
module.exports["RemixPanelButton"] = $e7d7957021bd9d4a$export$def261f8e2f8a585;

});

parcelRegister("jQW4q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7739ad8bf36e5bd9a55f1766d10483c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e73feb3a782b379c$var$_react = $e73feb3a782b379c$var$_interopRequireDefault((parcelRequire("42omo")));

var $e73feb3a782b379c$var$_baseNew = $e73feb3a782b379c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $e73feb3a782b379c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeRemix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Remix with Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e73feb3a782b379c$var$AiGenerativeRemixIcon = (props)=>/*#__PURE__*/ $e73feb3a782b379c$var$_react.default.createElement($e73feb3a782b379c$var$_baseNew.default, Object.assign({
        name: "AiGenerativeRemixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="M15.78 3.72a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM6 4.25a.75.75 0 0 1-.49.71l-1.1.4a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.41 0l-.4-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.48-.59L0 4.25l.01-.12a.75.75 0 0 1 .48-.59l1.1-.4a.5.5 0 0 0 .3-.3l.4-1.1.05-.11A.75.75 0 0 1 3 1.24l.12.01a.75.75 0 0 1 .54.38l.05.11.4 1.1c.05.14.16.25.3.3l1.1.4a.75.75 0 0 1 .49.71"/>`
    }, props));
$e73feb3a782b379c$var$AiGenerativeRemixIcon.displayName = 'AiGenerativeRemixIcon';
var $e73feb3a782b379c$var$_default = module.exports.default = $e73feb3a782b379c$var$AiGenerativeRemixIcon;

});

parcelRegister("6njW5", function(module, exports) {

let $4a445ae4024dc2f3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4a445ae4024dc2f3$var$load("6wr18"),
    $4a445ae4024dc2f3$var$load("55w8Y"),
    $4a445ae4024dc2f3$var$load("lHaTX"),
    $4a445ae4024dc2f3$var$load("ffEVr"),
    $4a445ae4024dc2f3$var$load("4RWFL"),
    $4a445ae4024dc2f3$var$load("9anPW"),
    $4a445ae4024dc2f3$var$load("fA1hG")
]).then(()=>parcelRequire('6UgwP'));

});


//# sourceMappingURL=RemixPanelButton.6cbe65ce.js.map
